import { FC } from 'react'
import { Stack, Text } from '@instabox/consumer-web-ui'
import { GetMarketByIdQuery, FormattedRichMessage } from '@instabox/consumer-web-shared'

import ContactUsLink from '../ContactUsLink'

const NegativeRating: FC<GetMarketByIdQuery['marketById']> = ({ email, sms, phone }) => {
  return (
    <Stack>
      <Text fontSize="sm">
        <FormattedRichMessage id="help.rating.negative.contact_us" />
      </Text>
      <ContactUsLink type="email" value={email} withIcon fontSize="sm" />
      <ContactUsLink type="phone" value={phone} withIcon fontSize="sm" />
      <ContactUsLink type="sms" value={sms} withIcon fontSize="sm" />
    </Stack>
  )
}

export default NegativeRating
